/**
 * Copyright (c) 2024, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { HHSeekAndFindOperation } from "app/models/hhseekandfind-operation-dto";
import { Url_Base } from "app/rest-constants";
import { RestService } from "./rest-service";



@Injectable()
export class HHSeekAndFindService {

  constructor(
    private restService: RestService
  ) { }

  public getAllSeekAndFindOperations(): Promise<HHSeekAndFindOperation[]> {
    const url = `${Url_Base}/hh/seekandfind-operations`;
    return this.restService.get<HHSeekAndFindOperation[]>(url);
  }

  public saveSeekAndFindOperation(op: HHSeekAndFindOperation): Promise<HHSeekAndFindOperation> {
    const url = `${Url_Base}/hh/seekandfind-operations`;
    return this.restService.post<HHSeekAndFindOperation>(url, op);
  }

}
